"use client";

import NextLink from 'next/link';
import { useCallback } from 'react';
import { useLoadingState } from '@/hooks/useLoadingState';
import { prefetch as swrPrefetch } from '@/hooks/useDirectus';
import type { LinkProps as NextLinkProps } from 'next/link';

interface ClientLinkProps extends NextLinkProps {
  children: React.ReactNode;
  className?: string;
  target?: string;
  onClick?: () => void;
  prefetch?: boolean;
}

export default function Link({ children, onClick, target, prefetch, ...props }: ClientLinkProps) {
  const { setIsLoading } = useLoadingState();

  const handleClick = () => {
    setIsLoading(true);
    if (onClick) onClick();
  };

  const handleMouseEnter = useCallback(() => {
    const href = typeof props.href === 'string' ? props.href : props.href?.pathname || '';

    if (!href || href.startsWith('http') || href.startsWith('mailto') || href.startsWith('tel')) {
      return;
    }

    const slug = href.replace(/^\/+|\/+$/g, '') || 'index';

    try {
      swrPrefetch.pageData(slug);

      if (href.includes('/blog')) {
        swrPrefetch.blogPosts(1, 6);
      }
    } catch {
      // Preload failures are non-critical
    }
  }, [props.href]);

  return (
    <NextLink
      {...props}
      onClick={handleClick}
      onMouseEnter={handleMouseEnter}
      prefetch={prefetch}
    >
      {children}
    </NextLink>
  );
} 